import { Directive } from '@angular/core';

/**
 * Make a div or other element behave like a button:
 * 1. Tab-focusable
 * 2. Advertised as role="button"
 * 3. Converts enter/space to click events
 * https://www.bennadel.com/blog/3633-giving-click-anchor-links-tab-access-using-a-directive-in-angular-7-2-15.htm
 * https://dev.to/tylerjdev/when-role-button-is-not-enough-dac
 */
@Directive({
  selector: '[fwButtonLike]',
  host: {
    tabindex: '0',
    role: 'button',
    '(keydown.enter)': '$event.preventDefault(); $event.target.click()',
    '(keydown.space)': '$event.preventDefault(); $event.target.click()',
  },
})
export class FwButtonLikeDirective {}
